import React from "react";
import "../../styles/gstr.scss";
import {
  formateDateTime,
  getFullMonthName,
} from "../../../../../utils/commonFunctions";
import { OptionsType } from "../../../../../commonTypes/universalTypes";
import { RedErrorIcon, WarningIcon } from "../../../../../assets/images";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Button } from "react-bootstrap";

type AppProps = {
  data: any;
  gst?: boolean;
  monthData?: OptionsType;
  handleAddARN?: (value: string) => void;
  selecteMonth?: string;
};

const GstrOneAutoFilledTable = ({
  data,
  gst,
  monthData,
  handleAddARN,
  selecteMonth
}: AppProps) => {
const monthDataValue = selecteMonth?.split("-");
  const [openARN, setOpenARN] = React.useState(false);
  const [ARNNumber, setARNNumber] = React.useState("");
  let month = getFullMonthName(monthData?.value?.split("-")?.[0]);

  let year = 20 + monthData?.value?.split("-")?.[1];

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setARNNumber(value);
  };

  return (
    <>
      <div className="table-bordered col-md-12 gstr">
        <table className='table table-striped"'>
          <tbody>
            <tr>
              <td className="left-table-columns col-md-4">1. GSTIN</td>
              <td className="col-md-8">
                {data?.gstIn ? data?.gstIn : "--/--"}
              </td>
            </tr>

            <tr>
              <td className="left-table-columns col-md-4">
                2(a). Legal name of the registered person
              </td>
              <td className="col-md-8">
                {data?.legalName ? data?.legalName : "--/--"}
              </td>
            </tr>

            <tr>
              <td className="left-table-columns col-md-4">
                2(b). Trade name, if any
              </td>
              <td className="col-md-8">
                {!gst
                  ? data?.label !== "Select Branch" &&
                    data?.label !== "Select GST No."
                    ? data?.label
                    : "--/--"
                  : data?.label !== "Select Branch" &&
                    data?.label !== "Select GST No."
                  ? data?.tradeName
                  : "--/--"}
              </td>
            </tr>

            <tr>
              <td className="left-table-columns col-md-4">2(c). ARN</td>
              <td className="col-md-8">
                {data?.ackNumber ? (
                  data?.ackNumber
                ) : gst&&handleAddARN ? (
                  <div
                    style={{
                      textDecoration: "underline",
                      cursor: "pointer",
                      color: "#dc3545",
                      width: "fit-content",
                    }}
                    onClick={() => setOpenARN(!openARN)}
                  >
                    Click to Add ARN
                  </div>
                ) : (
                  "--/--"
                )}
              </td>
            </tr>

            <tr>
              <td className="left-table-columns col-md-4">2(d). Date of ARN</td>
              <td className="col-md-8">
                {data?.gstr1FilingDate
                  ? formateDateTime(data?.gstr1FilingDate)
                  : "--/--"}
              </td>
            </tr>
            <tr>
              <td className="left-table-columns col-md-4">PAN Number</td>
              <td className="col-md-8">
                {data?.panNumber ? data?.panNumber : "--/--"}
              </td>
            </tr>
            <tr>
              <td className="left-table-columns col-md-4">
                Authorized Signatory Name
              </td>
              <td className="col-md-8">
                {data?.authorizedSignatoryName
                  ? data?.authorizedSignatoryName
                  : "--/--"}
              </td>
            </tr>
            <tr>
              <td className="left-table-columns col-md-4">
                Authorized Signatory Phone Number
              </td>
              <td className="col-md-8">
                {data?.authorizedSignatoryPhoneNumber
                  ? data?.authorizedSignatoryPhoneNumber
                  : "--/--"}
              </td>
            </tr>
            <tr>
              <td className="left-table-columns col-md-4">
                Authorized Signatory Email
              </td>
              <td className="col-md-8">
                {data?.authorizedSignatoryEmail
                  ? data?.authorizedSignatoryEmail
                  : "--/--"}
              </td>
            </tr>

            <tr>
              <td className="left-table-columns col-md-4">
                Authorized Signatory PAN Number
              </td>
              <td className="col-md-8">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span>
                    {data?.authorizedSignatoryPanNumber
                      ? data?.authorizedSignatoryPanNumber
                      : "--/--"}
                  </span>
                  {gst &&
                  data?.gstIn &&
                  data?.authorizedSignatoryPanNumber &&
                  data?.authorizedSignatoryPanDeatils?.status !== "VALID" ? (
                    <span
                      style={{
                        width: "fit-content",
                      }}
                      className=" ml-3 text-danger error-msg "
                    >
                      <span className="mr-1 ">
                        <img src={RedErrorIcon} alt="error" />
                      </span>
                      Please verify the Authorized Signatory PAN Number.
                    </span>
                  ) : gst &&
                    data?.gstIn &&
                    !data?.authorizedSignatoryPanNumber ? (
                    <span
                      style={{
                        width: "fit-content",
                      }}
                      className=" ml-3 text-danger error-msg"
                    >
                      <span className="mr-1">
                        <img src={RedErrorIcon} alt="error" />
                      </span>
                      Please enter the Authorized Signatory PAN Number.
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </td>
            </tr>

            <tr>
              <td className="left-table-columns col-md-4">Filed by</td>
              <td className="col-md-8">
                {data?.gstrFilingBy?.first_name
                  ? data?.gstrFilingBy?.first_name +
                    " " +
                    data?.gstrFilingBy?.last_name
                  : "--/--"}
              </td>
            </tr>

            {monthData ? (
              <tr>
                <td className="left-table-columns col-md-4">Period</td>
                <td className="col-md-8">{`${month} ${year}`?.trim()}</td>
              </tr>
            ) : (
              ""
            )}
          </tbody>
        </table>
      </div>

      <Modal
        isOpen={openARN}
        toggle={() => setOpenARN(true)}
        style={{ minWidth: "600px" }}
      >
        <ModalHeader
          className="pt-4 pl-4"
          toggle={() => {
            setOpenARN(!openARN);
          }}
        >
          Provide Application Reference Number (ARN)
        </ModalHeader>
        <ModalBody className="pl-4 pr-4">
          <div className="top-heading" style={{ fontSize: "16px" }}>
            ARN will help you track the status of your GST application.
          </div>
          <div>
            <div className="mt-2 asset_details_text_all_user">
              {" "}
              <span>
                <img src={WarningIcon} alt="warning" />
              </span>{" "}
              Submitting the ARN locks all invoices for {`${monthDataValue&&getFullMonthName(monthDataValue[0])} 20${monthDataValue&&monthDataValue[1]}`} month from further
              edits.
            </div>
          </div>
          <form>
            <div className="form-group mt-3">
              <div>
                <label className={"active"}>
                  Enter ARN Number <span className="color-red">*</span>
                </label>
                <div className="d-flex flex-row position-relative">
                  <input
                    type="text"
                    className={`form-control`}
                    name="text"
                    value={ARNNumber}
                    autoFocus
                    onChange={(e) => handleChange(e)}
                  />
                </div>
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <span
            className="pointer"
            onClick={() => {
              setARNNumber("");
              setOpenARN(!openARN);
            }}
          >
            Cancel
          </span>
          <Button
            color="primary ml-3"
            disabled={ARNNumber?.trim()?.length < 1}
            onClick={() => {
              handleAddARN && handleAddARN(ARNNumber);
              setOpenARN(!openARN);
              setARNNumber("");
            }}
          >
            Add
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default GstrOneAutoFilledTable;
